// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Calculate/components/CalculateResultsOfDesign/styles.scss
// module id = 176
// module chunks = 0